import { get } from "svelte/store";
import { projectSettings } from "../config";
import model from "../stores/modelStore";

window.gtm_var_web_visitor_id = window.gtm_var_web_visitor_id || false;

function getCookie(name) {
	var value = "; " + document.cookie;
	var parts = value.split("; " + name + "=");
	if (parts.length == 2) {
		return parts.pop().split(";").shift();
	}
	return null;
}

function userIdentifier(attempts) {
	attempts = attempts || 0;
	var maxAttempts = 20;

	try {
		// allow me to provide an override via GTM.
		var gtmIdOverride = window.gtm_var_web_visitor_id;
		if (window.gtm_var_web_visitor_id) {
			return window.gtm_var_web_visitor_id;
		}

		// get GA4 cookie.
		var ga4Cookie = getCookie("_ga");
		if (ga4Cookie) {
			// get the correct value from cookie:
			var uid = /.+\.(\d+\.\d+)$/gi.exec(ga4Cookie)[1];
			// add required prefix:
			var prefix = "ga_c_id|" + uid;
			return prefix;
		} else if (attempts < maxAttempts) {
			setTimeout(function () {
				userIdentifier(attempts + 1);
			}, 500);
		} else {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: "ga4_id_capture_timeout"
			});
		}
	} catch (err) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: "ga4_id_capture_error"
		});
	}
}

const formatPhoneNumber = (phoneNumber) => {
	if (phoneNumber) {
		let formattedNumber = phoneNumber.replace(/\s+/g, "");
		if (formattedNumber.startsWith("0")) {
			return formattedNumber.replace(/^0/, "+61");
		} else if (!formattedNumber.startsWith("+61")) {
			return "+61" + formattedNumber;
		}
		return formattedNumber;
	}
	return phoneNumber;
};

async function hash(string) {
	const utf8 = new TextEncoder().encode(string);
	const hashBuffer = await crypto.subtle.digest("SHA-256", utf8);
	const hashArray = Array.from(new Uint8Array(hashBuffer));
	const hashHex = hashArray.map((bytes) => bytes.toString(16).padStart(2, "0")).join("");
	return hashHex;
}

const pushDataLayer = async (data) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(data);
};

const registerFormStart = () => {
	const data = {
		class_action_name: projectSettings.classActionName,
		page_url: `${window.location.hostname}${window.location.pathname}`
	};
	const eventName = `class_action_form_start`;

	pushDataLayer({
		...data,
		event: eventName
	});
};

const getEmailDataPoints = async (emailAddress) => {
	let email = null;
	let emailHash = null;
	let emailHashGads = null;

	if (Array.isArray(emailAddress) && emailAddress.length > 0) {
		email = emailAddress[0];
	} else {
		email = emailAddress;
	}

	if (email) {
		emailHash = await hash(email.toLowerCase().trim());

		if (email.endsWith("@gmail.com") || email.endsWith("@googlemail.com")) {
			let arr = email.toLowerCase().trim().split("@");
			if (arr.length == 2) {
				let name = arr[0].replace(".", "");
				emailHashGads = await hash(`${name}@${arr[1]}`);
			}
		}
	}

	return { emailHash, emailHashGads };
};

const getPhoneDataPoints = async (phoneNumber) => {
	if (Array.isArray(phoneNumber) && phoneNumber.length > 0) {
		return await hash(phoneNumber[0]);
	} else {
		return await hash(phoneNumber);
	}
};

const getAdditionalDataPoints = async (model, type) => {
	let emails = { emailHash: null, emailHashGads: null };
	let phoneHash = null;

	if (model.contact) {
		let formattedPhoneNumber = formatPhoneNumber(model.contact.phone.phoneNumber);
		phoneHash = await getPhoneDataPoints(formattedPhoneNumber);
		emails = await getEmailDataPoints(model.contact.email.emailAddress);
	} else if (model.Contact) {
		let formattedPhoneNumber = formatPhoneNumber(model.Contact.Phone.PhoneNumberne);
		emails = await getEmailDataPoints(model.Contact.Email.EmailAddress);
		phoneHash = await getPhoneDataPoints(formattedPhoneNumber);
	}

	let data = {};
	if (emails.emailHash) data.hashed_email = emails.emailHash;
	if (emails.emailHashGads) data.hashed_email_gads = emails.emailHashGads;
	if (phoneHash) data.hashed_phone = phoneHash;

	if (type === "pageComplete") {
		data.class_action_behalf_of = 
			model.registrationType || model.RegistrationType || null;
	} else if (type === "submit") {
		data.reference_number =  
			model.registrationNumber || model.RegistrationNumber || null;
	}

	return data;
};

const registerPageComplete = async (pageName) => {
	model.update((m) => {
		m.TealiumId = userIdentifier();
		return m;
	});

	let data = {
		class_action_name: projectSettings.classActionName,
		class_action_phase_name: pageName,
		page_url: `${window.location.hostname}${window.location.pathname}`,
		...await getAdditionalDataPoints(get(model), "pageComplete")
	};

	const eventName = `class_action_form_phase_completed`;

	pushDataLayer({
		...data,
		event: eventName
	});
};

const registerSubmit = async () => {
	let data = {
		class_action_name: projectSettings.classActionName,
		page_url: `${window.location.hostname}${window.location.pathname}`,
		...await getAdditionalDataPoints(get(model), "submit")
	};

	const eventName = `class_action_form_submit`;

	pushDataLayer({
		...data,
		event: eventName
	});
};

const regFormPhone = async (phoneNumber) => {
	let formattedPhoneNumber = formatPhoneNumber(phoneNumber);

	var data = {
		click_text: "Call " + formattedPhoneNumber,
		click_url: "tel:" + formattedPhoneNumber,
		event_action: "user_click",
		event: "tel_link_click"
	};

	pushDataLayer(data);
};

const regFormEmail = async (emailAddress) => {
	var data = {
		click_text: emailAddress,
		click_url: "mailto:" + emailAddress,
		event_action: "user_click",
		event: "email_link_click"
	};

	pushDataLayer(data);
};

export { registerFormStart, registerPageComplete, registerSubmit, regFormEmail, regFormPhone };
